// src/lib/csvExport.ts
//
// Client-side CSV export shared by the analytics tabs. Same approach as the
// inventory action-queue export (no deps; UTF-8 BOM so Excel reads it
// correctly), generalized so each tab only declares its columns.

export type CsvColumns<T> = Array<[string, (row: T) => string | number | null | undefined]>;

export function exportCsv<T>(filename: string, cols: CsvColumns<T>, rows: T[]) {
  const esc = (v: string | number | null | undefined) => {
    const s = String(v ?? '');
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const csv = '﻿'
    + cols.map((c) => esc(c[0])).join(',') + '\n'
    + rows.map((r) => cols.map((c) => esc(c[1](r))).join(',')).join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename}-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
